export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';


/** WEBPACK FOOTER **
 ** ./src/modules/auth/actions/types.js
 **/